import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import ColorsTimeline from './ColorsTimeline';
import ClientProvider from './client';
export default createDemo(import.meta.url, ColorsTimeline, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/timeline/demos/colors/ColorsTimeline.tsx",
    "fileName": "ColorsTimeline.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Timeline from '@mui/lab/Timeline';\nimport TimelineItem from '@mui/lab/TimelineItem';\nimport TimelineSeparator from '@mui/lab/TimelineSeparator';\nimport TimelineConnector from '@mui/lab/TimelineConnector';\nimport TimelineContent from '@mui/lab/TimelineContent';\nimport TimelineDot from '@mui/lab/TimelineDot';\n\nexport default function ColorsTimeline() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <Timeline position=\"alternate\">\n      <TimelineItem>\n        <TimelineSeparator>\n          <TimelineDot color=\"secondary\" />\n          <TimelineConnector />\n        </TimelineSeparator>\n        <TimelineContent>Secondary</TimelineContent>\n      </TimelineItem>\n      <TimelineItem>\n        <TimelineSeparator>\n          <TimelineDot color=\"success\" />\n        </TimelineSeparator>\n        <TimelineContent>Success</TimelineContent>\n      </TimelineItem>\n    </Timeline>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 26,
        "focusedLines": 15,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Timeline from '@mui/lab/Timeline';\nimport TimelineItem from '@mui/lab/TimelineItem';\nimport TimelineSeparator from '@mui/lab/TimelineSeparator';\nimport TimelineConnector from '@mui/lab/TimelineConnector';\nimport TimelineContent from '@mui/lab/TimelineContent';\nimport TimelineDot from '@mui/lab/TimelineDot';\n\nexport default function ColorsTimeline() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <Timeline position=\"alternate\">\n      <TimelineItem>\n        <TimelineSeparator>\n          <TimelineDot color=\"secondary\" />\n          <TimelineConnector />\n        </TimelineSeparator>\n        <TimelineContent>Secondary</TimelineContent>\n      </TimelineItem>\n      <TimelineItem>\n        <TimelineSeparator>\n          <TimelineDot color=\"success\" />\n        </TimelineSeparator>\n        <TimelineContent>Success</TimelineContent>\n      </TimelineItem>\n    </Timeline>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 10
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "Timeline"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "position"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "alternate",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 11
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "TimelineItem"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 12
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "TimelineSeparator"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 13
            },
            [
              "          <",
              [
                "span",
                "pl-c1 di-jsx",
                "TimelineDot"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "color"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "secondary",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 14
            },
            [
              "          <",
              [
                "span",
                "pl-c1 di-jsx",
                "TimelineConnector"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 15
            },
            [
              "        </",
              [
                "span",
                "pl-c1 di-jsx",
                "TimelineSeparator"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 16
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "TimelineContent"
              ],
              ">Secondary</",
              [
                "span",
                "pl-c1 di-jsx",
                "TimelineContent"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 17
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "TimelineItem"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 18
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "TimelineItem"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 19
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "TimelineSeparator"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 20
            },
            [
              "          <",
              [
                "span",
                "pl-c1 di-jsx",
                "TimelineDot"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "color"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "success",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 21
            },
            [
              "        </",
              [
                "span",
                "pl-c1 di-jsx",
                "TimelineSeparator"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 22
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "TimelineContent"
              ],
              ">Success</",
              [
                "span",
                "pl-c1 di-jsx",
                "TimelineContent"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 23
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "TimelineItem"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 24
            },
            [
              "    </",
              [
                "span",
                "pl-c1 di-jsx",
                "Timeline"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 26,
    "focusedLines": 15,
    "collapsible": true,
    "externals": [
      "@mui/lab/Timeline",
      "@mui/lab/TimelineItem",
      "@mui/lab/TimelineSeparator",
      "@mui/lab/TimelineConnector",
      "@mui/lab/TimelineContent",
      "@mui/lab/TimelineDot"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
